var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more_horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.75C7.60457 8.75 8.5 9.64543 8.5 10.75C8.5 11.8546 7.60457 12.75 6.5 12.75C5.39543 12.75 4.5 11.8546 4.5 10.75C4.5 9.64543 5.39543 8.75 6.5 8.75ZM14.5 10.75C14.5 9.64543 13.6046 8.75 12.5 8.75C11.3954 8.75 10.5 9.64543 10.5 10.75C10.5 11.8546 11.3954 12.75 12.5 12.75C13.6046 12.75 14.5 11.8546 14.5 10.75ZM18.5 8.75C19.6046 8.75 20.5 9.64543 20.5 10.75C20.5 11.8546 19.6046 12.75 18.5 12.75C17.3954 12.75 16.5 11.8546 16.5 10.75C16.5 9.64543 17.3954 8.75 18.5 8.75Z",
    fill: "#05112E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/more_horizontal.8cd17e45db82e6f076356882912bb74c.svg";
export { ForwardRef as ReactComponent };